import { render, staticRenderFns } from "./ListPlanosFinalizados.vue?vue&type=template&id=7223afb9&"
import script from "./ListPlanosFinalizados.vue?vue&type=script&lang=js&"
export * from "./ListPlanosFinalizados.vue?vue&type=script&lang=js&"
import style0 from "./ListPlanosFinalizados.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports